import React from 'react'
import { COMPANY_NAME } from 'config/portal'

function getUploadParticipantAccordionItems() {
  return [
    {
      uuid: 'instructions',
      heading: '',
      panel: (
        <>
          <p>
            Please follow the steps below to upload your participant data file.
            The participant data submission process works best if you use the EZ
            Worksheet Template above, but it is not required.
          </p>
          <ol className="instructions-list">
            <li>
              After clicking on Upload File below, you will be asked to start
              the upload process by selecting your file.
            </li>
            <li>
              Select the file and then choose the name of the tab that your data
              is contained in, if applicable.
            </li>
            <li>
              Confirm the "Header Row" in your file where the names of the
              columns are specified. The row immediately after the header row
              must be the first row of participant data.
            </li>
            <li>
              Match the column names from your file to the column names that{' '}
              {COMPANY_NAME['long']} requires for submission. If you are missing
              any required columns, you will be notified of this when you
              attempt to proceed to the next step. If you use the template file,
              the system will auto-match all the headers and you only need to
              review and advance to the next step.
            </li>
            <li>
              Review the rows of participant data provided and resolve any
              issues identified by the system. Data from your original file may
              be reformatted by the system to a standard format (such as SSN,
              EIN, or Date of Birth). All cells highlighted in red must be
              corrected before you are able to proceed to the next step in the
              submission process. If you attempt to proceed without correcting
              all issues identified, the invalid rows will not be included in
              the submission to {COMPANY_NAME['long']}.
            </li>
          </ol>
          <p>
            Note: If you find that your file has many issues, it may be faster
            to make edits to the file offline in Excel then upload again when
            the changes have been made.
          </p>
        </>
      ),
    },
  ]
}
export default getUploadParticipantAccordionItems
